import { Pipe, PipeTransform } from '@angular/core';

import { CustomTranslationsService } from '../translations';
import { HeatingConfigurationDhqSensorsEcoModeLeadingValue } from '../../../projects/client';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateDhwEcoModeLeading',
})
export class TranslateDhwEcoModeLeadingPipe implements PipeTransform {
  constructor(
    private customTranslationsService: CustomTranslationsService,
    private translateService: TranslateService
  ) {}

  transform(value: keyof typeof HeatingConfigurationDhqSensorsEcoModeLeadingValue): string {
    if (value && this.customTranslationsService.DHW_ECO_MODES_LEADING[value]) {
      return this.translateService.instant(
        this.customTranslationsService.DHW_ECO_MODES_LEADING[value] ?? value
      );
    }

    return value;
  }
}
